import { render, staticRenderFns } from "./PageUserQyq.vue?vue&type=template&id=42c20fa4"
import script from "./PageUserQyq.vue?vue&type=script&lang=js"
export * from "./PageUserQyq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports